import { render } from "./Pending.vue?vue&type=template&id=5686ded4&scoped=true"
import script from "./Pending.vue?vue&type=script&lang=js"
export * from "./Pending.vue?vue&type=script&lang=js"

import "@/views/ClientSpace/custom-clientSpace.scss?vue&type=style&index=0&id=5686ded4&lang=scss&scoped=true"
import "./custom-pending.scss?vue&type=style&index=1&id=5686ded4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5686ded4"]])

export default __exports__